// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3KlLF","col":"styles_col__160hG"};